import dayjs from "dayjs";
import _ from "lodash/fp";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import advertisementDetailsLabel from "../../application_management/labels/advertisement_details_en.json";
import {
    registrationNo,
    schoolname,
} from "../../common/constants/regex";
import { fromUTCDate, preventDateManualTyping, toUTCDate } from "../../helpers/Datetime";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/qualification.css";
import { saveInternshipList } from "../actions/profileAction";
import common from "../labels/common_en.json";
import qualificationinformation from "../labels/qualification_information_en.json";
import qualificationinformation_hindi from "../labels/qualification_information_hin.json";
import numberformat from "../labels/serial_nos_en.json";
import QualificationTypeDropdown from "./QualificationTypeDropdown";
import useQualificationActions from "./useQualificationActions";


const InternshipQualification = ({ setActiveQualificationIndex, setActiveIntershipIndex, setActivePublicationIndex, enableEditProfileWithLock, profileStatus }) => {


    let [showModal, setShowModal] = useState(false);
    let [hideAddBtn, setHideAddBtn] = useState(true)
    const {
        handleQualificationChange,
        handleInternshipSubmit,
        setInternActionType,
        setQualificationState,
        register,
        handleSubmit,
        errors,
        qualificationState,
        currentEditQualificationIndex,
        control,
        isResultDateMandatory,
        watch
    } = useQualificationActions();
    const dispatch = useDispatch();

    let {
        qualificationsList,
        displayableQualificationList,
        internshipListForSave,
    } = useSelector((state) => state.profile, shallowEqual);

    const modalInternConfirm = () => {
        const updatedInternshipsList = internshipListForSave;

        // dispatch(saveInternshipsList(InternshipsList));
        dispatch(saveInternshipList(updatedInternshipsList));
        setShowModal(false);
    };
    return (
        <form
            className="qualifcation_form"
            autoComplete="off"
            // onSubmit={handleSubmit((e) => {
            //     handleQualificationInfoSubmit(e);
            // })}
            onSubmit={handleSubmit((e) => {
                handleInternshipSubmit(e);
            })}
        >
            <div className="row">
                <QualificationTypeDropdown />
                {/** Following div is to displayed conditionally */}

                {/* Internship Stream */}
                <div className="col-md-4 mb-3 mt-3 responsive-input-intern-stream">
                    <label className="float-start mb-0">
                        {numberformat["4.2"]}&nbsp;
                        {qualificationinformation.INTERNSHIP_STREAM}
                    </label>
                    <span> {qualificationinformation_hindi.INTERNSHIP_STREAM_HIN} </span>

                    {/* {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "} */}
                    <select
                        className="form-select bg-color"
                        value={qualificationState?.qualificationname}
                        // defaultValue={qualificationState?.qualificationname}
                        name="qualificationname"
                        // ref={register({ required: isResultDateMandatory })}
                        onInput={handleQualificationChange}
                    >
                        <option key={0} value="">
                            {qualificationsList.qualificationname ? qualificationsList.qualificationname : advertisementDetailsLabel.SELECT}
                        </option>

                        {qualificationsList?.length > 0 &&
                            qualificationsList.map((ele, index) => {
                                const subjectLabel = displayableQualificationList?.[index]?.subjectLabel || "";
                                const qualificationTypeCode = displayableQualificationList?.[index]?.qualificationtypecode || ele.qualificationtypecode;
                                if (qualificationTypeCode === "Pb") return null;
                                const optionText = `${ele.qualificationnamecode}  ${subjectLabel}`;
                                return (
                                    <option key={ele.id} value={optionText}>
                                        {optionText}
                                    </option>
                                );
                            })
                        }
                    </select>
                    {/* {_.get("qualificationname.type", errors) === "required" && (
                        <p className="errorText">
                            {qualificationinformation.MANDATORY_FIELD_MESSAGE}
                        </p>
                    )} */}
                </div>
                {/* internship FROM */}
                <div className="col-md-4 mb-3 mt-3 responsive-input-intern-fromDate">
                    <label className="float-start mb-0">
                        {numberformat["4.3"]}&nbsp;{qualificationinformation.INTERNSHIP_FROM}
                        <span> {qualificationinformation_hindi.RESULT_DATE_hin} </span>
                        {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "}
                    </label>
                    <Controller
                        name="internshipFromDate"
                        key={qualificationState.internshipFromDate ? "internshipFromDate" : "internshipFromDate1"}
                        defaultValue={
                            qualificationState?.internshipFromDate
                                ? dayjs(qualificationState.internshipFromDate).toDate()
                                : null
                        }
                        rules={{
                            required: isResultDateMandatory,
                            validate: (value) => {
                                if (!value) return false;
                                if (value > new Date()) return qualificationinformation.DATA_LTE_TODAY_MSG;
                                if (qualificationState.internshipToDate && value > qualificationState.internshipToDate) {
                                    return "From Date cannot be later than To Date";
                                }
                                return true;
                            }
                        }}
                        control={control}
                        render={({ onChange, value }) => (
                            <DatePicker
                                showIcon
                                selected={
                                    qualificationState.internshipFromDate
                                        ? dayjs(qualificationState.internshipFromDate).toDate()
                                        : fromUTCDate(value)
                                }

                                maxDate={new Date()}

                                onChange={(e) => {
                                    setQualificationState({
                                        ...qualificationState,
                                        internshipFromDate: toUTCDate(e),
                                    });
                                    onChange(toUTCDate(e));
                                }}
                                onKeyDown={preventDateManualTyping}
                                disabled={!isResultDateMandatory}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText={commonLabels.DATE_FORMAT}
                                dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                                className="form-control bg-color"
                                icon={
                                    <img
                                        src="/icons/calender.png"
                                        className="date-picker-icon"
                                        alt="date-icon"
                                    ></img>
                                }
                            />
                        )}
                    />
                    {_.get("internshipFromDate.type", errors) === "required" &&
                        (isResultDateMandatory ? (
                            <p className="errorText">
                                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
                            </p>
                        ) : (
                            ""
                        ))}
                    {_.get("internshipFromDate.type", errors) === "validate" && (
                        <p className="errorText">
                            {qualificationinformation.DATA_LTE_TODAY_MSG}
                        </p>
                    )}
                </div>
                {/* internship TO */}
                <div className="col-md-4 mb-3 mt-3 responsive-input-intern-toDate">
                    <label className="float-start mb-0">
                        {numberformat["4.4"]}&nbsp;{qualificationinformation.INTERNSHIP_TO}
                        <span> {qualificationinformation_hindi.INTERNSHIP_TO_HIN} </span>
                        {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "}
                    </label>
                    <Controller
                        name="internshipToDate"
                        rules={{
                            required: isResultDateMandatory,
                            validate: (value) => {
                                if (!value) return false;
                                if (value > new Date()) return qualificationinformation.DATA_LTE_TODAY_MSG;
                                if (qualificationState.internshipFromDate && value < qualificationState.internshipFromDate) {
                                    return "To Date cannot be earlier than From Date";
                                }
                                return true;
                            }
                        }}
                        key={qualificationState.internshipToDate ? "internshipToDate" : "resultDate1"}
                        defaultValue={
                            qualificationState?.internshipFromDate
                                ? dayjs(qualificationState.internshipFromDate).toDate()
                                : null // Use null instead of an empty string for DatePicker
                        }
                        control={control}
                        render={({ onChange, value }) => (
                            <DatePicker
                                showIcon
                                selected={
                                    qualificationState.internshipToDate
                                        ? dayjs(qualificationState.internshipToDate).toDate()
                                        : fromUTCDate(value)
                                }
                                maxDate={new Date()}
                                minDate={watch("internshipFromDate") || new Date()}
                                onChange={(e) => {
                                    setQualificationState({
                                        ...qualificationState,
                                        internshipToDate: toUTCDate(e),
                                    });
                                    onChange(toUTCDate(e));
                                }}
                                onKeyDown={preventDateManualTyping}
                                disabled={!isResultDateMandatory}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText={commonLabels.DATE_FORMAT}
                                dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                                className="form-control bg-color"
                                icon={
                                    <img
                                        src="/icons/calender.png"
                                        className="date-picker-icon"
                                        alt="date-icon"
                                    ></img>
                                }
                            />
                        )}
                    />
                    {_.get("internshipToDate.type", errors) === "required" &&
                        (isResultDateMandatory ? (
                            <p className="errorText">
                                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
                            </p>
                        ) : (
                            ""
                        ))}
                    {_.get("internshipToDate.type", errors) === "validate" && (
                        <p className="errorText">
                            {qualificationinformation.DATA_LTE_TODAY_MSG}
                        </p>
                    )}
                </div>
                {/* COLLEGE NAME */}
                <div className="col-md-4 mb-3 mt-3 responsive-input-intern-clgName">
                    <label className="float-start mb-0">
                        {numberformat["4.5"]}&nbsp;{qualificationinformation.INTERNSHIP_COLLEGE}
                        <span> {qualificationinformation_hindi.INTERNSHIP_COLLEGE_HIN} </span>
                        {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "}
                    </label>
                    <input
                        type="text"
                        className="form-control bg-color text-uppercase"

                        defaultValue={qualificationState.internshipCollege}
                        maxLength={60}
                        name="internshipCollege"
                        ref={register({
                            required: isResultDateMandatory,
                            pattern: schoolname,
                        })}
                        onInput={handleQualificationChange}
                    />
                    {_.get("internshipCollege.type", errors) === "required" &&
                        (isResultDateMandatory ? (
                            <p className="errorText">
                                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
                            </p>
                        ) : (
                            ""
                        ))}
                    {_.get("internshipCollege.type", errors) === "pattern" && (
                        <p className="errorText">
                            {qualificationinformation.ONLY_CHARATERS_NUMBERS}
                        </p>
                    )}
                </div>

                {/* CERTIFICATE NO */}
                <div className="col-md-4 mb-3 mt-3 responsive-input-intern-certiNo">
                    <label className="float-start mb-0">
                        {numberformat["4.6"]}&nbsp;{qualificationinformation.INTERNSHIP_CERTIFICATE_NO}
                        <span>{" "} {qualificationinformation_hindi.INTERNSHIP_CERTIFICATE_NO_HIN} </span>
                        {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "}
                    </label>
                    <input
                        type="text"
                        className="form-control bg-color text-uppercase"
                        defaultValue={qualificationState.internshipCertificate}
                        maxLength={30}
                        name="internshipCertificate"
                        ref={register({
                            required: isResultDateMandatory,
                            pattern: registrationNo,
                        })}
                        onInput={handleQualificationChange}

                    />
                    {_.get("internshipCertificate.type", errors) === "required" &&
                        (isResultDateMandatory ? (
                            <p className="errorText">
                                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
                            </p>
                        ) : (
                            ""
                        ))}
                    {_.get("internshipCertificate.type", errors) === "pattern" && (
                        <p className="errorText">
                            {qualificationinformation.ONLY_CHARATERS_NUMBERS}
                        </p>
                    )}
                </div>
                {/* ISSUE DATE */}
                <div className="col-md-4 mb-3 mt-3 responsive-input-intern-issueDate">
                    <label className="float-start mb-0">
                        {numberformat["4.7"]}&nbsp;{qualificationinformation.INTERNSHIP_ISSUE_DATE}{" "}
                        <span>{qualificationinformation_hindi.INTERNSHIP_ISSUE_DATE_HIN} </span>
                        {isResultDateMandatory ? <span className="redColor">*</span> : ""}{" "}
                    </label>
                    <Controller
                        name="internshipIssueDate"
                        rules={{
                            required: isResultDateMandatory,
                            validate: (value) => value <= new Date(),
                        }}
                        key={qualificationState.internshipIssueDate ? "internshipIssueDate" : "resultDate1"}

                        defaultValue={
                            qualificationState.internshipIssueDate
                                ? dayjs(qualificationState.internshipIssueDate).toDate()
                                : ""
                        }
                        control={control}
                        render={({ onChange, value }) => (
                            <DatePicker
                                showIcon
                                selected={
                                    qualificationState.internshipIssueDate
                                        ? dayjs(qualificationState.internshipIssueDate).toDate()
                                        : fromUTCDate(value)
                                }
                                maxDate={new Date()}
                                onChange={(e) => {
                                    setQualificationState({
                                        ...qualificationState,
                                        internshipIssueDate: toUTCDate(e),
                                    });
                                    onChange(toUTCDate(e));
                                }}
                                onKeyDown={preventDateManualTyping}
                                disabled={!isResultDateMandatory}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText={commonLabels.DATE_FORMAT}
                                dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                                className="form-control bg-color"
                                icon={
                                    <img
                                        src="/icons/calender.png"
                                        className="date-picker-icon"
                                        alt="date-icon"
                                    ></img>
                                }
                            />
                        )}
                    />
                    {_.get("internshipIssueDate.type", errors) === "required" &&
                        (isResultDateMandatory ? (
                            <p className="errorText">
                                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
                            </p>
                        ) : (
                            ""
                        ))}
                    {_.get("internshipIssueDate.type", errors) === "validate" && (
                        <p className="errorText">
                            {qualificationinformation.DATA_LTE_TODAY_MSG}
                        </p>
                    )}
                </div>
                {/* ISSUED BY */}
                <div className="col-md-4 mb-3 mt-3 responsive-input-intern-issueBy">
                    <label className="float-start mb-0">
                        {numberformat["4.8"]}&nbsp;
                        {qualificationinformation.INTERNSHIP_ISSUE_BY}{" "}
                        {qualificationinformation_hindi.INTERNSHIP_ISSUE_BY_HIN}{" "}
                        <span className="redColor">*</span>{" "}

                    </label>
                    <input
                        type="text"
                        className="form-control bg-color text-uppercase"
                        name="internshipIssuedBy"
                        ref={register({ required: true })}
                        defaultValue={
                            qualificationState &&
                            qualificationState.internshipIssuedBy
                        }
                        onInput={handleQualificationChange}
                    />
                    {_.get("internshipIssuedBy.type", errors) === "required" && (
                        <p className="errorText">
                            {qualificationinformation.MANDATORY_FIELD_MESSAGE}
                        </p>
                    )}
                </div>
            </div>
            <div className="text-center mb-5 mt-5">
                {
                    profileStatus !== true ? (
                        <>
                            {currentEditQualificationIndex !== -1 ? (
                                <button
                                    type="submit"
                                    name="edit"
                                    className=" btn btn-primary custom_button  m-1  "
                                    onClick={() => {
                                        setInternActionType("edit");
                                        setActiveQualificationIndex("");
                                        setActiveIntershipIndex("");
                                        setActivePublicationIndex("");
                                    }}

                                >
                                    {qualificationinformation.UPDATE}
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    name="add"
                                    className=" btn btn-primary custom_button  m-1  "
                                    onClick={(e) => {
                                        setInternActionType("add");
                                        setHideAddBtn(false);
                                    }}
                                >
                                    {qualificationinformation.ADD}
                                </button>
                            )}
                        </>
                    ) : (
                        enableEditProfileWithLock?.editProfileWithLock == "1" ? (
                            (() => {
                                const qualificationInfoList = enableEditProfileWithLock?.QualificationInfo?.split(",") || [];
                                const canCreate = qualificationInfoList.includes("C");
                                const canUpdate = qualificationInfoList.includes("U");

                                if (currentEditQualificationIndex !== -1 && canUpdate) {
                                    return (
                                        <button
                                            type="submit"
                                            name="edit"
                                            className=" btn btn-primary custom_button  m-1  "
                                            onClick={() => {
                                                setInternActionType("edit");
                                                setActiveQualificationIndex("");
                                                setActiveIntershipIndex("");
                                                setActivePublicationIndex("");
                                            }}

                                        >
                                            {qualificationinformation.UPDATE}
                                        </button>
                                    );
                                } else if (canCreate) {
                                    return (
                                        <button
                                            type="submit"
                                            name="add"
                                            className=" btn btn-primary custom_button  m-1  "
                                            onClick={(e) => {
                                                setInternActionType("add");
                                                setHideAddBtn(false);
                                            }}
                                        >
                                            {qualificationinformation.ADD}
                                        </button>
                                    );
                                }

                            })()
                        ) : ""
                    )
                }

            </div>
            {/* {<div className="save_btn_div text-center">
                <button
                    type="button"
                    className="save_btn"
                    onClick={() => {
                        setShowModal(true);
                    }}
                    disabled={isDisableAllTabSave}
                >
                    {common.SAVE}
                </button>
            </div>} */}
            <Modal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                }}
                backdrop="static"
            >
                <Modal.Header className="custom-modal-header logout_heading">
                    <Modal.Title className="logout_title">
                        {qualificationinformation.SAVE_INTERNSHIP_MODAL_TITLE}
                    </Modal.Title>
                    <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={() => setShowModal(false)}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <label>
                        {qualificationinformation.SAVE_INTERNSHIP_CONFIRMATION_MESSAGE}
                    </label>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-secondary"
                        onClick={() => {
                            setShowModal(false);
                        }}
                    >
                        {common.CANCEL}
                    </button>
                    <button className=" btn btn-primary custom_button " onClick={modalInternConfirm}>
                        {common.CONFIRM}
                    </button>
                </Modal.Footer>
            </Modal>
        </form>
    );
};
export default InternshipQualification;
